import { useFocusable } from '@noriginmedia/norigin-spatial-navigation'
import { useCursorNavigation } from './useCursorNavigation'

import type {
  UseHybridFocusableConfig,
  UseHybridFocusableResult,
} from './types'

export function useHybridFocusable<T = unknown>(
  config: UseHybridFocusableConfig<T>
): UseHybridFocusableResult {
  const { disabled = false, ...focusableConfig } = config
  const focusableResult = useFocusable(focusableConfig)
  const { isHovered } = useCursorNavigation({
    ref: focusableResult.ref,
    focusKey: focusableResult.focusKey,
    onEnterPress: config.onEnterPress,
    extraProps: config.extraProps,
    onHover: config.onHover,
    disabled,
  })

  return {
    ...focusableResult,
    isHovered,
  }
}

export default useHybridFocusable
